import { ModuleSpec } from '../types';
import { Icon, id, label, route } from './config';
import menuItem from './MenuItem';
import routes from './routes';

export { Icon } from './config';

const einsaetzeModule: ModuleSpec = {
  id,
  label,
  icon: Icon,
  enabled: () => true,
  dataProviders: [],
  menuItem,
  route,
  routes,
  supportsMissions: true,
};

export default einsaetzeModule;
